import React from 'react'
import { UILabelsProvider } from '@duck/ui'
import { useTar } from '@/modules'

/**
 * Provides translated labels for all UI package components (MultiPick, SinglePick, etc.).
 * Wrap your app (e.g. in Layout) once; components read their slice from context.
 * Add more keys to the value object as the UI package grows (e.g. dialog, command).
 */
export function UILabelsFromI18n({ children }: { children: React.ReactNode }) {
  const { t } = useTar()
  const value = React.useMemo(
    () => ({
      multiPick: {
        placeholder: t('common.selectItems'),
        emptyMessage: t('common.noItemsFound'),
        itemsLabel: t('common.items'),
        searchPlaceholder: t('common.search'),
        createItemLabel: t('common.createItemLabel'),
      },
    }),
    [t]
  )
  return <UILabelsProvider value={value}>{children}</UILabelsProvider>
}
